export const locales = {
    en: {
        label: "English",
        dayjs: () => import('dayjs/locale/en'),
        flatpickr: null,
        i18n: () => import("./locales/en/translations.json"),
        flag: 'united-kingdom'
    },
    fr: {
        label: "French",
        dayjs: () => import('dayjs/locale/fr'),
        flatpickr: null,
        i18n: () => import("./locales/fr/translations.json"),
        flag: 'france'
    },
}